import * as types from "../../constants/actionTypes";

export const setLoader = (data) => {
    return {
        type: types.MODULE_AUTH_SET_LOADER,
        payload: data
    }
};

export const checkDirectURL = (email, generatedUri, history) => {
    return ({
        type: types.MODULE_AUTH_CHECK_URL,
        email,
        generatedUri,
        history
    })
}

export const initFormVerifikasiPassword =  () => {
    return ({
        type: types.MODULE_AUTH_INIT_FORM_VERIFIKASI_PASSWORD
    })
}

export const initFormLogin =  () => {
    return ({
        type: types.MODULE_AUTH_INIT_FORM
    })
}
export const initFormRegister =  () => {
    return ({
        type: types.MODULE_AUTH_INIT_FORM_REGISTER
    })
}
export const initFormRegisterKlinik =  () => {
    return ({
        type: types.MODULE_AUTH_INIT_FORM_REGISTER_KLINIK
    })
}

export const handleStateForm =  (property, value) => {
    return ({
        type: types.MODULE_AUTH_HANDLE_STATE_FORM,
        property,
        value
    })
}

export const handleStateFormRegister = (property, value) => {
    return ({
        type: types.MODULE_AUTH_HANDLE_STATE_FORM_REGISTER,
        property,
        value
    })
}

export const handleStateFormRegisterKlinik = (property, value) => {
    return ({
        type: types.MODULE_AUTH_HANDLE_STATE_FORM_REGISTER_KLINIK,
        property,
        value
    })
}

export const handleStateFormVerifikasiPassword = (property, value) => {
    return ({
        type: types.MODULE_AUTH_HANDLE_STATE_FORM_VERIFIKASI_PASSWORD,
        property,
        value
    })
}

export const postLogin = (history) => {
    return ({
        type: types.MODULE_AUTH_SUBMIT_FORM_LOGIN,
        history
    })
}

export const postSubmitRegister = (history) => {
    return ({
        type: types.MODULE_AUTH_SUBMIT_FORM_REGISTER,
        history
    })
}

export const postSubmitRegisterKlinik = (history) => {
    return ({
        type: types.MODULE_AUTH_SUBMIT_FORM_REGISTER_KLINIK,
        history
    })
}

export const postVerifikasiPassword = (email, password, generatedUri, history) => {
    return ({
        type: types.MODULE_AUTH_SUBMIT_VERIFIKASI_PASSWORD,
        email,
        password,
        generatedUri,
        history
    })
}